import {
  Box,
  Button,
  Flex,
  Grid,
  IconButton,
  Select,
  SimpleGrid,
  Switch,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';

import React, { useEffect, useState } from 'react';
import Card from 'components/card/Card';
import BackButton from 'components/BackButton';
import { MdDelete, MdEdit } from 'react-icons/md';
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import TeamMemberModal from 'views/team/components/TeamMemberModal';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from 'loaders/Loader';
import toast from 'react-hot-toast';
import { createAPIEndPoint } from 'config/api/api';
import AssignLocationModal from 'views/team/components/AssignLocationModal';
import DeleteModal from 'components/deleteModal/DeleteModal';
import ErrorMessage from 'components/error-message';
import { logoutUser } from 'utils';
import { formatUSPhoneNumber } from 'utils';
import moment from 'moment';
import { toProperCase } from 'utils/formatting';

const columnHelper = createColumnHelper();

// const locationTableData = [
//   {
//     name: 'John Doe',
//     email: 'xyz@gmail.com',
//     phone: '123456789',
//     designation: 'Staff',
//   },
// ];

export default function LocationDetails(props) {
  const navigate = useNavigate();
  const location = useLocation();
  // const { id } = location.state;
  const pathParts = location.pathname.split('/');
  const id = pathParts[pathParts.length - 1];
  const { ...rest } = props;

  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [locationTableData, setLocationTableData] = useState([]);
  console.log(' LocationDetails ~ locationTableData:', locationTableData);

  // Columns definition
  const columns = [
    columnHelper.accessor('staff_name', {
      id: 'name',
      header: () => (
        <Text fontSize="12px" color="gray.400" fontWeight="bold">
          NAME
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700">
          {info.getValue() || 'N/A'}
        </Text>
      ),
    }),
    columnHelper.accessor('email', {
      id: 'email',
      header: () => (
        <Text fontSize="12px" color="gray.400" fontWeight="bold">
          Email
        </Text>
      ),
      cell: (info) => (
        <Text
          color={textColor}
          textTransform="none"
          fontSize="sm"
          fontWeight="700"
        >
          {info.getValue() || 'N/A'}
        </Text>
      ),
    }),
    columnHelper.accessor('phone', {
      id: 'phone',
      header: () => (
        <Text fontSize="12px" color="gray.400" fontWeight="bold">
          Phone
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700">
          {formatUSPhoneNumber(info.getValue()) || 'N/A'}
        </Text>
      ),
    }),
    columnHelper.accessor('designation', {
      id: 'designation',
      header: () => (
        <Text fontSize="12px" color="gray.400" fontWeight="bold">
          Designation
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700">
          {info.getValue() || 'N/A'}
        </Text>
      ),
    }),
    columnHelper.accessor('action', {
      id: 'action',
      header: () => (
        <Text fontSize="12px" color="gray.400" fontWeight="bold">
          ACTION
        </Text>
      ),
      cell: (info) => {
        const handleEditClick = (e) => {
          onOpen();
          setType('edit');
        };

        const handleOpenDeleteModal = () => {
          setSelectedItem(info.row.original);
          setDeleteModalOpen(true);
        };

        return (
          <Box display="flex">
            {/* <IconButton
              icon={<MdEdit style={{ marginLeft: '-1px' }} />}
              aria-label="Edit Details"
              colorScheme="brand"
              size="sm"
              mr="6px"
              onClick={handleEditClick}
            /> */}
            <IconButton
              icon={<MdDelete style={{ marginLeft: '-1px' }} />}
              aria-label="Delete"
              colorScheme="red"
              size="sm"
              onClick={handleOpenDeleteModal}
            />
          </Box>
        );
      },
    }),
  ];

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [type, setType] = React.useState('add');
  const [sorting, setSorting] = React.useState([]);
  const [data, setData] = React.useState(() => [...locationTableData]);

  React.useEffect(() => {
    if (locationTableData) {
      setData([...locationTableData]); // Creates a fresh copy
    }
  }, [locationTableData]);

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const textColorSecondary = 'gray.400';
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const [isEnabled, setIsEnabled] = useState(true); // For status toggle

  const [loading, setLoading] = useState(true);
  console.log('🚀 ~ LocationDetails ~ loading:', loading);
  const [locationData, setLocationData] = useState({});

  const getLocation = async () => {
    try {
      setLoading(true);
      const response = await createAPIEndPoint('clinic_locations').fetchById(
        `/${id}`,
      );
      const locationData = response.data;

      setLocationData(locationData);

      setLoading(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.error || 'Error fetching location details',
      );
      if (error?.response?.data?.error.includes('Bearer token')) {
        logoutUser(navigate);
      }
      setLoading(false);
    }
  };

  const getLocationMembers = async () => {
    try {
      const response = await createAPIEndPoint(
        'staff_locations/get_by_location',
      ).fetchById(`/${id}`);
      const locationData = response.data.staff_members;

      setLocationTableData(locationData);
    } catch (error) {
      console.log(
        error?.response?.data?.error || 'Error fetching locations member',
      );
    }
  };

  useEffect(() => {
    getLocation();
    getLocationMembers();
  }, [id]);

  const [selectedItem, setSelectedItem] = React.useState();

  const handleCloseDeleteModal = () => setDeleteModalOpen(false);

  const handleDeleteItem = async () => {
    try {
      setLoading(true); // ✅ show loader

      await createAPIEndPoint(
        `staff_locations/delete/${selectedItem.staff_id}/`,
      ).delete(id);

      await getLocationMembers(); // ✅ refresh staff list
      toast.success('Staff member deleted successfully!');
      setDeleteModalOpen(false);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Error deleting staff member');
    } finally {
      setLoading(false); // ✅ hide loader
    }
  };

  const [isAssignOpen, setIsAssignOpen] = useState(false);

  const handleAssignClick = () => {
    setIsAssignOpen(true);
  };

  return (
    <>
      {' '}
      {loading && <Loader />}
      <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
        <BackButton />
        {/* Main Fields */}
        <Grid
          templateColumns={{
            base: '1fr',
            lg: '1fr',
          }}
          templateRows={{
            base: 'repeat(2, 1fr)',
            lg: '1fr',
          }}
          gap={{ base: '20px', xl: '20px' }}
        >
          <Card mb={{ base: '0px', '2xl': '20px' }} {...rest}>
            <Text
              color={textColorPrimary}
              fontWeight="bold"
              fontSize="2xl"
              mt="8px"
              mb="24px"
            >
              Location Details
            </Text>

            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  Name:
                </Text>
                <Text color={textColorSecondary} fontSize="md">
                  {locationData.display_name ||
                    locationData.location_name ||
                    'N/A'}
                </Text>
              </Box>

              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  Email:
                </Text>
                <Text color={textColorSecondary} fontSize="md">
                  {locationData.email || 'N/A'}
                </Text>
              </Box>

              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  Phone:
                </Text>
                <Text color={textColorSecondary} fontSize="md">
                  {formatUSPhoneNumber(locationData.phone) || 'N/A'}
                </Text>
              </Box>

              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  Address:
                </Text>
                <Text color={textColorSecondary} fontSize="md">
                  {locationData.address || 'N/A'}
                </Text>
              </Box>

              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  City:
                </Text>
                <Text color={textColorSecondary} fontSize="md">
                  {locationData.city || 'N/A'}
                </Text>
              </Box>

              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  State:
                </Text>
                <Text color={textColorSecondary} fontSize="md">
                  {locationData.state || 'N/A'}
                </Text>
              </Box>

              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  Postal Code:
                </Text>
                <Text color={textColorSecondary} fontSize="md">
                  {locationData.postal_code || 'N/A'}
                </Text>
              </Box>

              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  Location Type:
                </Text>
                <Text color={textColorSecondary} fontSize="md">
                  {toProperCase(locationData.location_type) || 'N/A'}
                </Text>
              </Box>

              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  Greeting Message:
                </Text>
                <Text color={textColorSecondary} fontSize="md">
                  {locationData.greeting_message || 'N/A'}
                </Text>
              </Box>

              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  Map Link:
                </Text>
                <Text color={textColorSecondary} fontSize="md">
                  {locationData.map_link ? (
                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${locationData.map_link}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View on Map
                    </a>
                  ) : (
                    'N/A'
                  )}
                </Text>
              </Box>

              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  SIP URI:
                </Text>
                <Text color={textColorSecondary} fontSize="md">
                  {locationData.sip_uri || 'N/A'}
                </Text>
              </Box>
            </SimpleGrid>
          </Card>
          <Card mb={{ base: '0px', '2xl': '20px' }} {...rest}>
            <Flex
              justify="space-between"
              align="center"
              flexWrap="wrap"
              mb="24px"
            >
              <Text
                color={textColorPrimary}
                fontWeight="bold"
                fontSize={{ base: 'xl', md: '2xl' }}
                mt="8px"
              >
                Staff Members for This Location
              </Text>

              <Button
                w={{ base: '100%', sm: 'auto' }}
                variant="brand"
                fontWeight="500"
                onClick={handleAssignClick}
                size="sm"
                borderRadius="12px"
                mt={{ base: '8px', sm: '0' }}
              >
                Assign Location
              </Button>
            </Flex>

            <Box overflowX="auto">
              <Table variant="striped" color="gray.500" mb="24px" mt="12px">
                <Thead>
                  {table.getHeaderGroups().map((headerGroup) => (
                    <Tr key={headerGroup.id}>
                      {headerGroup.headers.map((header) => (
                        <Th
                          key={header.id}
                          colSpan={header.colSpan}
                          pe="10px"
                          borderColor={borderColor}
                          cursor="pointer"
                          onClick={header.column.getToggleSortingHandler()}
                        >
                          <Flex justifyContent="space-between" align="center">
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext(),
                            )}
                          </Flex>
                        </Th>
                      ))}
                    </Tr>
                  ))}
                </Thead>
                <Tbody>
                  {table
                    .getRowModel()
                    .rows.slice(0, 11) // You can remove slice to show all rows
                    .map((row) => (
                      <Tr key={row.id}>
                        {row.getVisibleCells().map((cell) => (
                          <Td
                            key={cell.id}
                            fontSize="14px"
                            borderColor="transparent"
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext(),
                            )}
                          </Td>
                        ))}
                      </Tr>
                    ))}
                </Tbody>
              </Table>

              {!loading && locationTableData.length === 0 && (
                <ErrorMessage source="staff memebers" />
              )}
            </Box>
          </Card>
        </Grid>
        <TeamMemberModal isOpen={isOpen} onClose={onClose} type={type} />

        <AssignLocationModal
          isOpen={isAssignOpen}
          onClose={() => setIsAssignOpen(false)}
          isLocationId={id}
          fetchAgain={getLocationMembers}
        />

        <DeleteModal
          isOpen={isDeleteModalOpen}
          onClose={handleCloseDeleteModal}
          onDelete={handleDeleteItem}
          selectedItem={selectedItem?.staff_name} // Item name to be deleted
        />
      </Box>
    </>
  );
}
